import { ModelEvalV2CardUI } from '@scale/compass-ui/cards/model_eval/card';

export const ModelEvalV2CardUIOverride = {
  ...ModelEvalV2CardUI,
  isDefault: false,
};
